import { ConductorPageType } from "@faire/web-api--source/indigofair/data/ConductorPageType";
import { route as homeRoute } from "@faire/web-api--source/routes/www/root";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

export const useConductorPageType = (): keyof typeof ConductorPageType => {
  const { pathname } = useLocation();
  const isHomePage = pathMatchesRoute(pathname, homeRoute);
  return isHomePage
    ? ConductorPageType.CONDUCTOR_HOME_PAGE
    : ConductorPageType.CONDUCTOR_PAGE_TYPE_UNKNOWN;
};
